(function ($) {
	// On Dom Ready
	$(function () {
		// Toggle team search form
		$(".team-search-header .btn-toggle-search").on("click", function (e) {
			e.preventDefault();
			$(this).toggleClass("active");
			$(".team-search-wrapper .search-form").slideToggle();
		});
	});
})(jQuery);
